import { render, staticRenderFns } from "./AvatarHandler.vue?vue&type=template&id=652a14f2&scoped=true"
import script from "./AvatarHandler.vue?vue&type=script&lang=js"
export * from "./AvatarHandler.vue?vue&type=script&lang=js"
import style0 from "./AvatarHandler.vue?vue&type=style&index=0&id=652a14f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a14f2",
  null
  
)

export default component.exports